import { useSelector } from 'react-redux';

import { MirrorService } from 'services/MirrorService';

import { isAdditionalPriceEnabledSelector } from 'store/common/selectors';

export const useVatText = () => {
  const isAdditionalPriceEnabled = useSelector(
    isAdditionalPriceEnabledSelector
  );

  return {
    isVatTextEnabled: isAdditionalPriceEnabled || MirrorService.isMidSite,
    isVatTextOnlyOnMidEnabled: MirrorService.isMidSite,
  };
};
